export interface MaintenanceAlertDto {
  title: string;
  description?: string | null;
  endTime?: string | null;
  startTime?: string | null;
  status?: MaintenanceStatus | null;
}

export enum MaintenanceStatus {
  SCHEDULED = 'scheduled',
  WARNING = 'warning',
  ACTIVE = 'active',
  KICKING = 'kicking',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  READY_FOR_UPGRADE = 'ready_for_upgrade',
}

export interface MaintenanceProgressDto {
  status: MaintenanceStatus;
  totalTables: number;
  kickedTables: number;
  totalSeats: number;
  kickedSeats: number;
  errors: string[];
  lastUpdated: Date | string;
}

export interface MaintenanceConfigDto {
  alert: MaintenanceAlertDto | null;
  status: MaintenanceStatus | null;
  progress?: MaintenanceProgressDto;
}

export interface LobbyAlertDto {
  text: string;
  color: 'green' | 'orange' | 'red' | 'purple';
  endDate?: string | null;
}
